import React, { useEffect, useState, useCallback } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { useNavigate } from "react-router-dom";

import ConfirmBuyModal from "../components/ConfirmBuyModal";

import { ITreasureContract,NFTContarct, USDTContarct,NFTDataContract } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTDataContractABI from "../abis/NFTDataContractABI.json";

import Loader from "../components/Loader";
import BNB from "../assets/bnb.svg";
import nftimage from "../assets/img/package-nft.jpg";
import { FaCopy, FaCheck, FaCartArrowDown } from "react-icons/fa";

const NFTMarketPlace = () => {
  const navigate = useNavigate();
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [allNFTs, setAllNFTs] = useState([]);
  const [visibleNFTs, setVisibleNFTs] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [loadingSkeleton] = useState(Array(12).fill(0));
  const [activeTab, setActiveTab] = useState("All NFTs");
  const [pageSize, setPageSize] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const [userRank, setUserRank] = useState(0);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusText, setStatusText] = useState({ visible: false });

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";
  // 🔹 CURRENT TIME (seconds)
  const getNow = () => Math.floor(Date.now() / 1000);
  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "TradeHistory") navigate("/my-nft-history");
    else if (tab === "NFT Activity") navigate("/nft-trade-history");
  };

  // INIT WEB3
  useEffect(() => {
    if (client?.transport) setWeb3(new Web3(client.transport));
    else if (window.ethereum) setWeb3(new Web3(window.ethereum));
  }, [client]);

 

const loadAllNFTData = useCallback(async () => {
  if (!web3) return;

  setLoading(true);

  try {
    const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
    const NFTData = new web3.eth.Contract(
      NFTDataContractABI,
      NFTDataContract
    );

    const activeTokenIds = await NFT.methods
      .getAllActiveListedNFTs()
      .call();

    console.log("ACTIVE IDS:", activeTokenIds);

    const results = await Promise.allSettled(
      activeTokenIds.map(async (id) => {
        try {
          const d = await NFTData.methods.getNFTDetails(id).call();

          // ❗ safety check
          if (!d || !d.ownerAddr || d.ownerAddr === "0x0000000000000000000000000000000000000000") {
            return null;
          }

          return {
            tokenId: id.toString(),
            price: Number(web3.utils.fromWei(d.priceUSDT || "0", "ether")),
            owner: d.ownerAddr,
            image: d.imageURI,
          };
        } catch (err) {
          console.warn("NFT FAILED:", id, err);
          return null;
        }
      })
    );

    const nftList = results
      .filter(r => r.status === "fulfilled" && r.value)
      .map(r => r.value);

    // ✅ hide own NFTs only when address exists
    const filtered = address
      ? nftList.filter(
          nft => nft.owner.toLowerCase() !== address.toLowerCase()
        )
      : nftList;

    console.log("FINAL NFT COUNT:", filtered.length);

    setAllNFTs(filtered);
    setVisibleNFTs(filtered);

  } catch (err) {
    console.error("NFT Load Error:", err);
  } finally {
    setLoading(false);
  }
}, [web3, address]);

useEffect(() => {
  if (web3 && address) {
    loadAllNFTData();
  }
}, [web3, address, loadAllNFTData]);


  // FILTERING
  // const filtered = visibleNFTs.filter((n) => {
  //   if (n.owner?.toLowerCase() === address?.toLowerCase()) return false;
  //   if (!search) return true;
  //   return (
  //     n.tokenId.includes(search) ||
  //     n.owner?.toLowerCase().includes(search.toLowerCase())
  //   );
  // });

  const filtered = visibleNFTs.filter((n) => {
  if (n.owner?.toLowerCase() === address?.toLowerCase()) return false;
  // 🔥 price ≥ 190 requires rank >= 1
  // if (Number(n.price) >= 190 && userRank < 1) {
  //   return false;
  // }
  // search filter
  if (!search) return true;
  return (
    n.tokenId.includes(search) ||
    n.owner?.toLowerCase().includes(search.toLowerCase())
  );
});


  // PAGINATION
  const totalRecords = filtered.length;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const paginatedNFTs = filtered.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  // ============================================================
  // BUY NOW → OPEN MODAL
  // ============================================================
    const handleBuyNow = (nft) => {
    setSelectedNFT(nft);
    setShowModal(true);
    setStatusText({
      visible: false,
      type: "",
      title: "",
      message: "",
      persist: false,
    });
  };

  // ============================================================
  // STEP 1 — APPROVE USDT (PreAuthorize)
  // ============================================================
  // const PreAuthorizeNFT = async (setStatusTextCallback) => {
  //   try {
  //     const priceWei = web3.utils.toWei(selectedNFT.price.toString(), "ether");
  //     const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

  //     setStatusTextCallback({
  //       visible: true,
  //       type: "loading",
  //       title: "Approving USDT",
  //       message: "Please wait…",
  //     });

  //     const allowance = await USDT.methods
  //       .allowance(address, NFTContarct)
  //       .call();

  //     if (window.BigInt(allowance) >= window.BigInt(priceWei)) return true;

  //     await USDT.methods
  //       .approve(NFTContarct, priceWei)
  //       .send({ from: address });

  //     return true;
  //   } catch (err) {
  //     setStatusTextCallback({
  //       visible: true,
  //       type: "error",
  //       title: "Approval Failed",
  //       message: err.message,
  //     });
  //     return false;
  //   }
  // };

  const fetchUserRank = async () => {
  if (!web3 || !address) return;

  try {
    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    const rank = await Contract.methods
      .getUserRank(address)
      .call();
        const rankNum = Number(rank);
        setUserRank(rankNum);

    // alert(`Your Rank is: ${rankNum}`); // 🔥 ALERT HERE
    // setUserRank(Number(rank));
  } catch (err) {
    console.error("Rank fetch error:", err);
    setUserRank(0);
  }
};




useEffect(() => {
  if (web3 && address) {
    fetchUserRank();
  }
}, [web3, address]);

  const PreAuthorizeNFT = async () => {
    try {

        // ⭐ STEP 1: USER REGISTERED CHECK
          const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
          const user = await Contract.methods.objUser(address).call();
          if (!user?.userId || user.userId === "0") {
            setStatusText({
              visible: true,
              type: "error",
              title: "Not Registered",
              message: "Your account is not activated yet Please purchase to complete your registration.",
              persist: true,
              setStatusText,
            });
            return; // ❌ STOP HERE (MetaMask will NOT open)
          }

          const ContractNFT = new web3.eth.Contract(NFTABI, NFTContarct);
          const userCapping = await ContractNFT.methods.getUserCappingStatus(address).call();

          const totalCapping = window.BigInt(userCapping.totalCapping);
          const usedCapping = window.BigInt(userCapping.usedCapping);
          const availableCapping = window.BigInt(userCapping.availableCapping);
      
        // const priceWei = web3.utils.toWei(selectedNFT.price.toString(), "ether");
        const priceWei = window.BigInt(
  web3.utils.toWei(selectedNFT.price.toString(), "ether")
);

// 2️⃣ +2 token → wei → BigInt
const twoWei = window.BigInt(
  web3.utils.toWei("2", "ether")
);
        const approveAmount = priceWei +twoWei;

        // //  STEP 3: CAPPING CHECK (IMPORTANT)
        if (priceWei > availableCapping) {
          setStatusText({
            visible: true,
            type: "error",
            title: "Capping Limit Exceeded",
            message:
              "You cannot purchase this NFT because it exceeds your available capping limit.",
            persist: true,
          });
          return false; //  STOP (MetaMask will NOT open)
        }
      const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

      setStatusText({
        visible: true,
        type: "loading",
        title: "Approving USDT",
        message: "Please wait…",
      });

      const allowance = await USDT.methods
        .allowance(address, NFTContarct)
        .call();

      if (window.BigInt(allowance) >= window.BigInt(approveAmount)) return true;

      await USDT.methods
        .approve(NFTContarct, approveAmount)
        .send({ from: address });

      return true;
    } catch (err) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Approval Failed",
        message: err.message,
        persist: true,
        // ensure modal can close by clicking OK or X — modal will call status.onClose if provided
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
        },
      });
      return false;
    }
  };


  // ============================================================
  // STEP 2 — BUY NFT
  // ============================================================
  // const BuyNFT = async (setStatusTextCallback) => {
  //   try {
  //     const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

  //     setStatusTextCallback({
  //       visible: true,
  //       type: "loading",
  //       title: "Buying NFT",
  //       message: "Please wait…",
  //     });

  //     await NFT.methods.buyNFT(selectedNFT.tokenId).send({ from: address });

  //     setStatusTextCallback({
  //       visible: true,
  //       type: "success",
  //       title: "Success",
  //       message: `NFT #${selectedNFT.tokenId} Purchased Successfully`,
  //     });

  //     await loadAllNFTData();
  //     return true;
  //   } catch (err) {
  //     setStatusTextCallback({
  //       visible: true,
  //       type: "error",
  //       title: "Purchase Failed",
  //       message: err.message,
  //     });
  //     return false;
  //   }
  // };

   const BuyNFT = async () => {
    try {
      const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

      setStatusText({
        visible: true,
        type: "loading",
        title: "Buying NFT",
        message: "Please wait…",
        persist: false,
      });

      await NFT.methods.buyNFT(selectedNFT.tokenId).send({ from: address });

        // Remove the purchased NFT from the list immediately
        setAllNFTs((prev) =>
          prev.filter((nft) => nft.tokenId !== selectedNFT.tokenId)
        );
        setVisibleNFTs((prev) =>
          prev.filter((nft) => nft.tokenId !== selectedNFT.tokenId)
        );

      setStatusText({
        visible: true,
        type: "success",
        title: "Success",
        message: `NFT #${selectedNFT.tokenId} Purchased Successfully`,
        persist: true, // show OK button
        // when user clicks OK (or we can call onClose), hide modal and reload data
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
          // reload NFT list (no full page refresh)
          loadAllNFTData();
        },
      });

      // we already call loadAllNFTData() inside onClose so no immediate call here
      return true;
    } catch (err) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Purchase Failed",
        message: err.message,
        persist: true,
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
        },
      });
      return false;
    }
  };



  // ============================================================
  // FINAL CONFIRM BUTTON INSIDE MODAL
  // ============================================================
    const handleConfirm = async () => {
    const approved = await PreAuthorizeNFT();
    if (!approved) return;
  
    await BuyNFT();
  };

  const [copiedIndex, setCopiedIndex] = useState(null);
  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1200);
  };

  const maskAddress = (addr) =>
    addr ? addr.slice(0, 4) + "***" + addr.slice(-4) : "";

  if (loading) return <Loader />;

  return (
    <div className="page">
      <h4 className="mb-3">
        <span className="text-warning">NFT</span>{" "}
        <span className="fw-lighter">Marketplace</span>
      </h4>

      {/* Top Tabs */}
      <div className="row justify-content-between">
        <div className="col-md-4">
          <div className="filter-left mb-3">
            {["All NFTs", "NFT Activity", "TradeHistory"].map((tab) => (
              <a
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </a>
            ))}
          </div>
        </div>

        <div className="col-md-6 mb-3">
          <div className="filter-right">
            <input
              type="text"
              placeholder="Search NFTs..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="desc">DESC</option>
              <option value="asc">ASC</option>
            </select> */}

            <select
              value={pageSize}
              onChange={handlePageSizeChange}
              style={{ marginLeft: 10 }}
            >
              <option value="4">4</option>
              <option value="8">8</option>
              <option value="16">16</option>
              <option value="32">32</option>
              <option value="64">64</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>
      </div>

      {/* Total Counter */}
      <p className="mb-2 text-end">
        Total NFTs: <b>{totalRecords}</b> | Page: {currentPage}/{totalPages}
      </p>

      {/* NFT GRID */}
      <div className="row">
        {paginatedNFTs.map((nft, i) => (
          <div className="col-md-4 col-lg-3 mb-4" key={i}>
            <div className="nft">
              <div className="main">
                <img
                  className="tokenImage"
                  src={`${nft.image}?v=1`}
                  alt="NFT"
                  style={{ borderRadius: 10 }}
                />

                <h2>NFT #{nft.tokenId}</h2>
              

                <div className="tokenInfo">
                  <div className="price">
                    <ins>◘</ins>
                    <p>{formatBalance(nft.price)} USDT</p>
                  </div>
                  <div className="duration">
                    <ins>◷</ins>
                    <p>ON SALE</p>
                  </div>
                </div>

                <hr />

                {/* <div className="creator">
                  <div className="wrapper">
                    <img
                      src={BNB}
                      alt="BNB"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                  </div>

                  <p>
                    <ins>Owner</ins> {maskAddress(nft.owner)}
                  </p>

                  <div className="ref-copy-box">
                    <button
                      className="copy-btn"
                      onClick={() => handleCopy(nft.owner, i)}
                    >
                      {copiedIndex === i ? (
                        <FaCheck className="copy-icon copied" />
                      ) : (
                        <FaCopy className="copy-icon" />
                      )}
                    </button>
                  </div>
                </div> */}

                <button
                  className="new_joining_btn"
                  onClick={() => handleBuyNow(nft)}
                >
                  <FaCartArrowDown className="me-2" />
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Skeleton Loading */}
        {/* {loadingSkeleton.map((_, i) => (
          <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
            <div className="skeleton-card">
              <div className="skeleton-box"></div>
              <div className="NFT-card-body">
                <div className="skeleton-line w-50"></div>
                <div className="skeleton-line w-30"></div>
              </div>
            </div>
          </div>
        ))}
      </div> */}

        {/* ✅ SKELETON → ONLY WHEN NFT = 0 */}
        {loading && paginatedNFTs.length === 0 &&
          Array.from({ length: pageSize }).map((_, i) => (
            <div className="col-md-4 col-lg-3 mb-4" key={"s" + i}>
              <div className="skeleton-card">
                <div className="skeleton-box"></div>
                <div className="NFT-card-body">
                  <div className="skeleton-line w-50"></div>
                  <div className="skeleton-line w-30"></div>
                </div>
              </div>
            </div>
          ))}

                {paginatedNFTs.length === 0 &&
            Array.from({ length: pageSize }).map((_, i) => (
              <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
                <div className="skeleton-card">
                  <div className="skeleton-box"></div>
                  <div className="NFT-card-body">
                    <div className="skeleton-line w-50"></div>
                    <div className="skeleton-line w-30"></div>
                  </div>
                </div>
              </div>
            ))}
        </div>


      {/* Pagination */}
      <div className="pagination-box">
        <button disabled={currentPage === 1} onClick={prevPage}>
          Previous
        </button>
        <button disabled={currentPage === totalPages} onClick={nextPage}>
          Next
        </button>
      </div>

      {/* MODAL HERE */}
      <ConfirmBuyModal
        open={showModal}
        pkg={selectedNFT}
         purchaseType="nft"
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        status={statusText}
         setStatusText={setStatusText} 
      />
    </div>
  );
};

export default NFTMarketPlace;
